module.exports = __webpack_public_path__ + "img/instant-saure.58da36f1.png";